import { render, staticRenderFns } from "./PageHeadIconNew.vue?vue&type=template&id=37594270&scoped=true"
import script from "./PageHeadIconNew.vue?vue&type=script&lang=ts"
export * from "./PageHeadIconNew.vue?vue&type=script&lang=ts"
import style0 from "./PageHeadIconNew.vue?vue&type=style&index=0&id=37594270&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37594270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37594270')) {
      api.createRecord('37594270', component.options)
    } else {
      api.reload('37594270', component.options)
    }
    module.hot.accept("./PageHeadIconNew.vue?vue&type=template&id=37594270&scoped=true", function () {
      api.rerender('37594270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/PageHeadIconNew.vue"
export default component.exports